import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ServiceDeliveryGroupsComponent } from './service-delivery-groups.component';

const routes: Routes = [
  {
    path: '',
    component: ServiceDeliveryGroupsComponent,
    data: { title: 'Service Delivery Groups' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceDeliveryGroupsRoutingModule {}

@NgModule({
  imports: [
    ServiceDeliveryGroupsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ServiceDeliveryGroupsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ServiceDeliveryGroupsModule {}
